<template>
  <div class="home-banner">
    <div class="add-btn">
      <el-button
        type="primary"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('741') : false
        "
        @click="addBanner"
        >添加Banner</el-button
      >
    </div>
    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="bannerTableRef"
        class="banner-table"
        :data="bannerTableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column
          v-for="item in tableHeader"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="item.prop == 'image_str'">
              <img
                style="width: 160px; height: auto"
                :src="scope.row[item.prop]"
              />
            </div>
            <div v-else-if="item.prop == 'min_type'">
              {{ scope.row[item.prop] | minTypeText }}
            </div>
            <div v-else-if="item.prop == 'position'">
              {{ scope.row[item.prop] | positionText }}
            </div>
            <div v-else-if="item.prop == 'status'" class="banner-status">
              <i :style="stateStyle(scope.row[item.prop])"></i>
              {{ scope.row[item.prop] | statusText }}
            </div>

            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status != 2"
              @click="infoEdit(scope.row)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('741') : false
              "
              size="medium"
              >编辑</el-button
            >

            <el-button
              v-if="scope.row.status == 2"
              @click="infoDetail(scope.row)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('740') : false
              "
              size="medium"
              >详情</el-button
            >

            <el-button
              v-if="scope.row.status != 2"
              @click="changeStatus(scope.row, 2)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('742') : false
              "
              size="medium"
              >发布</el-button
            >

            <el-button
              v-if="scope.row.status != 1 && scope.row.status != 3"
              @click="changeStatus(scope.row, 3)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('742') : false
              "
              size="medium"
              >下架</el-button
            >

            <el-button
              v-if="scope.row.status == 1 || scope.row.status == 3"
              @click="infoDel(scope.row)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('743') : false
              "
              size="medium"
              >删除</el-button
            >
            <el-button
              @click="toData(scope.row.banner_id)"
              type="text"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1049') : false
              "
              size="medium"
              >数据</el-button
            >
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="置顶"
              placement="top"
            >
              <el-button
                @click="updateSort(scope.$index, 1)"
                size="medium"
                type="text"
                icon="el-icon-upload2"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('739') : false
                "
                style="font-size: 20px"
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="置底"
              placement="top"
            >
              <el-button
                @click="updateSort(scope.$index, 2)"
                size="medium"
                type="text"
                icon="el-icon-download"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('739') : false
                "
                style="font-size: 20px"
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="上移"
              placement="top"
            >
              <el-button
                @click="updateSort(scope.$index, 3)"
                size="medium"
                type="text"
                icon="el-icon-top"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('739') : false
                "
                style="font-size: 20px"
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="下移"
              placement="top"
            >
              <el-button
                @click="updateSort(scope.$index, 4)"
                size="medium"
                type="text"
                icon="el-icon-bottom"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('739') : false
                "
                style="font-size: 20px"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <add-or-editor
      :dialog="dialog"
      :id="banner_id"
      :isDisable="isDisable"
      :type="2"
      @close="close"
    ></add-or-editor>
  </div>
</template>

<script>
import marketing from "../../../api/marketing";
import AddOrEditor from "./components/addOrEditor.vue";
export default {
  components: {
    AddOrEditor,
  },
  data() {
    return {
      dialog: false,
      isDisable: false,
      tableHeader: [
        {
          label: "图片",
          prop: "image_str",
        },
        {
          label: "操作类型",
          prop: "min_type",
        },
        {
          label: "Banner位置",
          prop: "position",
        },
        {
          label: "Banner说明",
          prop: "desc",
        },
        {
          label: "Banner状态",
          prop: "status",
        },
      ],
      bannerTableData: [],
      banner_id: -1,
    };
  },
  filters: {
    statusText(val) {
      switch (val) {
        case 1:
          return "待发布";
        case 2:
          return "已发布";
        case 3:
          return "已下架";
        default:
          return val;
      }
    },
    minTypeText(val) {
      switch (val) {
        case 0:
          return "无动作";
        case 1:
          return "原生路由";
        case 2:
          return "跳转链接";
        default:
          return val;
      }
    },
    positionText(val) {
      switch (val) {
        case 1:
          return "下方";
        case 2:
          return "左侧";
        case 3:
          return "右侧";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 状态
    stateStyle(val) {
      switch (val) {
        case 1:
          return { backgroundColor: "#E6A23C" }; // 待发布
        case 2:
          return { backgroundColor: "#1ABC9C" }; // 已发布
        case 3:
          return { backgroundColor: "#FF0000" }; // 已下架
        default:
          return val;
      }
    },
    getList() {
      marketing.getDoctorBannerList({ type: 2 }).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.bannerTableData = data.list;
        }
      });
    },
    // 添加
    addBanner() {
      this.banner_id = -1;
      this.dialog = true;
    },
    // 编辑
    infoEdit(data) {
      this.banner_id = data.banner_id;
      this.dialog = true;
    },
    // 详情
    infoDetail(data) {
      this.banner_id = data.banner_id;
      this.dialog = true;
      this.isDisable = true;
    },
    close(data) {
      this.dialog = false;
      if (data == 1) {
        this.getList();
      }
      this.isDisable = false;
    },
    //排序
    updateSort(index, sort) {
      if (this.bannerTableData.length == 1) {
        this.$message.warning("只有一条数据哦");
        return;
      }
      let data = this.bannerTableData[index];
      this.bannerTableData.splice(index, 1);
      //置顶
      if (sort == 1) {
        this.bannerTableData.splice(0, 0, data);
      }
      //置底
      if (sort == 2) {
        this.bannerTableData.push(data);
      }
      //上移
      if (sort == 3) {
        this.bannerTableData.splice(index - 1, 0, data);
      }
      //下移
      if (sort == 4) {
        this.bannerTableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.bannerTableData.map((item) => {
        item = _.pick(item, ["banner_id", "sort"]);
        return item;
      });

      marketing.editDoctorBannerSort({ list }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },

    // 发布/下架
    changeStatus(data, status) {
      let params = Object.assign(_.pick(data, ["banner_id"]), { status });
      marketing.offOnDoctorBanner(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success(`${status === 2 ? "发布成功" : "下架成功"}`);
          this.getList();
        }
      });
    },
    // 删除
    infoDel(data) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        marketing.delDoctorBanner({ banner_id: data.banner_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
    toData(banner_id) {
      this.$router.push({
        path: "bannerdata",
        query: {
          banner_id,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-banner {
  .add-btn {
    text-align: left;
    margin: 0 0 20px 0;
  }
  .banner-table {
    .banner-status {
      i {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }
  }
}
</style>
